import { useEffect, useRef } from "react";
import { useDragLayer, useDrop } from "react-dnd";
import { createPortal } from "react-dom";

export const ScrollBottomDropTarget = (props: any) => {
    const scrollDown = () => {
        const el = props.listItemRef?.current;
        if (!el) return;
        el.scrollBy({ top: 10, behavior: "auto" });
    };

    const scrollBottomDropRef = useRef(null);
    const [{ isOver }, drop] = useDrop({
        accept: "booking",
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
    });

    const { isDragging } = useDragLayer((monitor) => ({
        isDragging: monitor.isDragging(),
    }));

    drop(scrollBottomDropRef);

    useEffect(() => {
        if (!isOver) {
            return;
        }

        const intervalId = window.setInterval(() => {
            scrollDown();
        }, 16);

        return () => {
            window.clearInterval(intervalId);
        };
    }, [isOver]);

    return createPortal(
            <div
                ref={scrollBottomDropRef}
                style={{
                    position: "fixed",
                    zIndex: !isDragging ? -50 : 1010,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: 60,
                    width: "100%",
                    //backgroundColor: isOver ? "blue" : "red"
                    // @ts-ignore
                }}
            />,
            document.getElementById("dispo_content"),
    );
};
